import React, { useState } from 'react';
import { downloadFile } from '../../../../lib/iprs-react-library/src/SharedComponents/IprsHealthPortal/FileTreeComponents/utils/fileDownloadUtils';

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB');
};

const OutputReportRow = ({ report, api, onDownloaded }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);
        downloadFile(report.DownloadGuid, api, report.Name);

        try {
            await api.transact("MarkOutputReportDownloaded", {
                OutputReportTransferId: report.PkOutputReportTransferId,
                Downloaded: true,
            });
            onDownloaded(report.PkOutputReportTransferId);
        } catch (err) {
            console.error("Failed to mark report as downloaded", err);
        }
        setDownloading(false);
    };

    const rowStyle = report.Downloaded
        ? { opacity: 0.7 }
        : { fontWeight: 'bold' };

    return (
        <tr style={rowStyle}>
            <td>{report.ClientName}</td>
            <td>{report.PatientName}</td>
            <td>{report.CaseId}</td>
            <td>{report.ReportTypeName}</td>
            <td>{formatDate(report.DateInserted)}</td>
            <td>
                <button
                    className="btn btn-sm btn-primary"
                    onClick={handleDownload}
                    disabled={downloading}
                >
                    {downloading ? 'Downloading...' : 'Download'}
                </button>
            </td>
        </tr>
    );
};

export default OutputReportRow;
